export const TrustTriageContent = {
  pageTitle: 'Make changes to an existing trust',
  pageDescription: 'Answer a few questions so we can ensure you’re in the right place!',
  continueButton: 'Continue',
  clientQuestion: 'Are you a Vanguard client?',
  updateTrustOrTrusteeQuestion: 'What would you like to do with the trust account?',
  updateTrustCheckbox: 'Update the name, date, or tax ID',
  updateTrusteeCheckbox: 'Add myself as a trustee or remove a deceased trustee',
  successorOrLivingTrusteeQuestion: 'Are you the successor trustee or only living trustee?',
  passedAwayQuestion: 'Has someone associated with the trust passed away?',
  trustReportingUnderDecedentsSSNQuestion:
    'Is the trust reporting under the decedents Social Security number?',
  radioButtonHintError: 'Make a selection to continue',
  infoCard: {
    SSN: {
      title: 'How it works',
      description:
        `When the creator of a trust passes away and the trust was reporting under their SSN, you must re-register the trust using an EIN, unless there is a surviving grantor. This process opens a new trust account, registered under the new EIN, or surviving grantor’s SSN, and transfers the assets from the previous trust account into the new account.` +
        '<br><br>' +
        `<i><b>Please note:</b> you need to obtain a new EIN before completing this process. To apply for one, visit <a class="c11n-link c11n-link--reinforced c11n-link--normal" href="https://www.irs.gov/" target="_blank"><span class="c11n-link__content">IRS.gov</span></a>.</i>`,
    },
    EIN: {
      title: 'How it works',
      description:
        `When you update trust information, such as the Tax ID, name, or date, you’re essentially creating a new trust account that will be registered with the new information, eliminating the existing account.` +
        '<br><br>' +
        `<i><b>Please note:</b> you need to obtain a new EIN before completing this process. To apply for one, visit <a class="c11n-link c11n-link--reinforced c11n-link--normal" href="https://www.irs.gov/" target="_blank"><span class="c11n-link__content">IRS.gov</span></a>.</i>`,
    },
  },
  rightRailAccordion: [
    {
      title: `What if I need to add or remove trustees for reasons unrelated to a death?`,
      content:
        `At this time, we can't collect the extra signatures needed through this process and will need you to call 877-662-7447(M–F, 8 a.m. to 8 p.m., ET) to begin this request.` +
        '<br><br>' +
        `Please note: removing a trustee due to incapacitation or resignation will require additional documents such as a letter or resignation and/or report of incapacitation.`,
    },
    {
      title: `What if I need to add multiple trustees?`,
      content: `At this time, we can't collect the extra signatures needed through this process and will need you to call 877-662-7447(M–F, 8 a.m. to 8 p.m., ET) to begin this request.`,
    },
    {
      title: `What if I want to transfer between trust accounts?`,
      content:
        `If you need to update trust information and want to transfer assets between two existing accounts, you'll first need to update the information using this process, and then complete an internal transfer.` +
        '<br><br>' +
        `<a class="c11n-link c11n-link--independent c11n-link--secondary c11n-link--normal" href="https://personal1.vanguard.com/cwp-change-of-ownership-angular/internal-transfer/overview"><span class="c11n-link__content">Visit our internal transfers experience</span></a> to transfer assets between two existing trusts.`,
    },
  ],
};
